import React from "react";
import { Navigate, useLocation } from "react-router-dom";

/**
 * React Router v6 guard.
 * Wrap protected route elements with <RequireAuth>...</RequireAuth>.
 */
export const RequireAuth = ({ children }) => {
  const location = useLocation();
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};

export default RequireAuth;
